var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectImageContainer"},[_c('img',{attrs:{"src":_vm.imageSrc(_vm.imageSource),"alt":_vm.caption,"x":"50%","y":"50%"}}),_c('h4',[_vm._v(_vm._s(_vm.caption))])])}
var staticRenderFns = []

export { render, staticRenderFns }